import { Component } from '@angular/core';
import {TopBarComponent} from "../../top-bar/top-bar.component";
import { NavBarComponent } from "../nav-bar/nav-bar.component";
import {HeroTerapiaFisicaComponent} from "./hero-terapia-fisica/hero-terapia-fisica.component";
import {ServicesTerapiaFisicaComponent} from "./services-terapia-fisica/services-terapia-fisica.component";
import {
  RecomendationsTerapiaFisicaComponent
} from "./recomendations-terapia-fisica/recomendations-terapia-fisica.component";
import {PromotionsFeaturedComponent} from "../promotions-featured/promotions-featured.component";
import {FooterPersonaComponent} from "../footer-persona/footer-persona.component";
import {InfoTerapiaFisicaComponent} from "./info-terapia-fisica/info-terapia-fisica.component";
import {PromocionesTerapiaFisicaComponent} from "./promociones-terapia-fisica/promociones-terapia-fisica.component";
import {FloatButtonComponent} from "../../float-button/float-button.component";

@Component({
  selector: 'app-terapia-fisica',
  standalone: true,
  imports: [
    TopBarComponent,
    NavBarComponent,
    HeroTerapiaFisicaComponent,
    ServicesTerapiaFisicaComponent,
    RecomendationsTerapiaFisicaComponent,
    PromotionsFeaturedComponent,
    FooterPersonaComponent,
    InfoTerapiaFisicaComponent,
    PromocionesTerapiaFisicaComponent,
    FloatButtonComponent
  ],
  templateUrl: './terapia-fisica.component.html',
  styleUrl: './terapia-fisica.component.css'
})
export class TerapiaFisicaComponent {

}
